import { fetchAuthedUser } from '@/api/user'
import { queryKeys } from '@/lib/query-keys'
import { useAuthStore } from '@/store/auth'
import { useOrganizationStore } from '@/store/organization'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

// Define auth status types for more precise state management
export type AuthStatus =
  | 'INITIAL_LOADING' // Initial loading state, not determined yet
  | 'AUTHENTICATED' // Successfully authenticated with a user
  | 'UNAUTHENTICATED' // Authentication completed but no user (not signed in)
  | 'ERROR' // Authentication failed due to error

export const UserLoader = () => {
  const isLoadingOrganizations = useOrganizationStore((s) => s.isLoading)
  const orgError = useOrganizationStore((s) => s.error)
  const setAuthState = useAuthStore((s) => s.setAuthState)
  const isLoadingExternalAuth = useAuthStore((s) => s.isLoadingExternalAuth)
  const hasExternalAuth = useAuthStore((s) => s.hasExternalAuth)

  const {
    data: user,
    error: userError,
    isLoading: isLoadingUser,
  } = useQuery({
    queryKey: queryKeys.user.me(),
    queryFn: fetchAuthedUser,
    enabled: hasExternalAuth,
  })

  // Calculate the overall system loading state
  const isLoading =
    isLoadingExternalAuth || isLoadingUser || isLoadingOrganizations

  // whenever any of these change, push into the store
  useEffect(() => {
    setAuthState({
      isLoading,
      user,
      error: userError ?? orgError,
    })
  }, [setAuthState, isLoading, user, userError, orgError])

  return null
}
